import { DecodedItsoMessageUploadController } from './decoded-itso-message-upload.controller';
import { DecodedItsoMessageUploadListController } from './list/decoded-itso-message-upload-list.controller';
import { IControllerConstructor } from 'angular';

/**
 * The entry point the tap events module
 */
export const initialise = () => {

  angular.module('app.decoded-itso-message-upload', [
    'pascalprecht.translate',
    'actora.services',
    'app.layout',
    'app.components',
    
  ]).config(['$stateProvider', '$urlRouterProvider', '$locationProvider', ($stateProvider, $urlRouterProvider, $locationProvider) => {
    $locationProvider.hashPrefix('');

    $stateProvider.state('decoded-itso-message-upload', {
      url: '/decoded-itso-message-upload',
      templateUrl: 'app/angularJS/features/abt/decoded-itso-message-upload/decoded-itso-message-upload.html',
      controller: 'DecodedItsoMessageUploadController',
      controllerAs: 'vm',
      parent: 'common'
    }).state('decoded-itso-message-upload-list', {
      url: '/decoded-itso-message-upload-list',
      templateUrl: 'app/angularJS/features/abt/decoded-itso-message-upload/list/decoded-itso-message-upload-list.html',
      controller: 'DecodedItsoMessageUploadListController',
      controllerAs: 'vm',
      params: {
        decodedItsoMessages: undefined
      },
      parent: 'common'
    });

    $urlRouterProvider.otherwise('/');
  }])
  .controller('DecodedItsoMessageUploadController', <IControllerConstructor>DecodedItsoMessageUploadController)
  .controller('DecodedItsoMessageUploadListController', <IControllerConstructor>DecodedItsoMessageUploadListController);
};